import React, { Component } from "react";

import "zrender/lib/svg/svg";
import echarts from "echarts/lib/echarts";
import "echarts/lib/component/legend";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import Util from "../util";
import "./lineEchartPerformanceTrends.css";

class LineEchart extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  createSingEcharts = (function () {
    let myChart = null;
    return function () {
      if (myChart) {
        return myChart;
      }
      if (window.isLess47) {
        return (myChart = echarts.init(document.getElementById("SuperLine")));
      } else {
        return (myChart = echarts.init(document.getElementById("SuperLine"), null, { renderer: "svg" }));
      }
    };
  })();
  shouldComponentUpdate(nextProps = {}, nextState = {}) {
    const thisProps = this.props || {}, thisState = this.state || {};
    for (const key in nextProps) {
      if (thisProps[key] !== nextProps[key] ) {
        return true;
      }
    }
    for (const key in nextState) {
      if (thisState[key] !== nextState[key] ) {
        return true;
      }
    }
    
    return false;
}
  setEchart = (xData = [], data = [], xBase = [], baseData = [], formatter) => {
    if (window.isLess47) {
      var myChart = echarts.init(document.getElementById("SuperLine"));
    } else {
      var myChart = echarts.init(document.getElementById("SuperLine"), null, { renderer: "svg" });
    }
    myChart.clear();
    myChart.resize();
    myChart.setOption(setLineOption(xData, data, xBase, baseData, formatter));
    // 默认选中最右一项弹出tooltip

    const timer = setTimeout(() => {
      clearTimeout(timer);
      
      if (!xBase.length && !xData.length) return;
      if ((!xBase.length && xData.length) || xData[xData.length - 1] >= xBase[xBase.length - 1]) {
        myChart.dispatchAction({
          type: "showTip",
          seriesIndex: 0, // 系列的 index
          dataIndex: data.length - 1, // 数据的 index
        });
      }
      if ((xBase.length && !xData.length) || xData[xData.length - 1] < xBase[xBase.length - 1]) {
        myChart.dispatchAction({
          type: "showTip",
          seriesIndex: 1, // 系列的 index
          dataIndex: baseData.length - 1, // 数据的 index
        });
      }
     const echartsDOM= document.querySelector("#tip");
     if(echartsDOM)echartsDOM.style.display = "none";
    }, 900);

  };
  componentDidMount() {
    let { xData, baseData, xBase, data, formatter } = this.props;
    if (!xData) {
      xData = [];
      data = [];
    }
    if (!xBase) {
      xBase = [];
      baseData = [];
    }
    console.log(xData, baseData, data, formatter);
    this.setEchart(xData, data, xBase, baseData, formatter);
  }
  componentWillUpdate(nextProps, nextState) {}
  componentDidUpdate() {
    let { xData, baseData, data, xBase, formatter } = this.props;
    if (!xData) {
      xData = [];
      data = [];
    }
    if (!xBase) {
      xBase = [];
      baseData = [];
    }
    this.setEchart(xData, data, xBase, baseData, formatter);
  }
  componentWillUnmount() {
    var myChart = echarts.init(document.getElementById("SuperLine"));
  }
  getColor = (value) => {
    if (!value && value != 0) return;
    if (value === "--") return "#333";
    if (value >= 0) return "#F8515C";
    return "#1DA96B";
  };
  render() {
    const { lastIncome, lastBase } = this.props.lineDataLast;
    let { xData, xBase } = this.props;
    if (!xData) {
      xData = [];
    }
    if (!xBase) {
      xBase = [];
    }
    return (
      <div style={{ position: "relative" }}>
        <div id="tip" className="PT_describe" style={{ position: "absolute" }}>
          <div className="PT_data">
            本策略 <span className="PT_describe_colon">:</span>
            {!lastIncome && lastIncome != 0 ? <span style={{ color: "#333" }}>--</span> : <span style={{ color: this.getColor(lastIncome) }}>{Util.toPercent(lastIncome)}</span>}
          </div>
          <div className="PT_base_data">
            业绩基准 <span className="PT_describe_colon">:</span>
            {!lastBase && lastBase != 0 ? <span style={{ color: "#333" }}>--</span> : <span style={{ color: this.getColor(lastBase) }}>{Util.toPercent(lastBase)}</span>}
          </div>
          <img style={{ width: ".24rem", marginLeft: ".1rem" }} src={require("../img/n_icon_what@2.png")} />
        </div>
        <div id="SuperLine" style={{ width: "100%", height: 360, overflow: "hidden" }} />
      </div>
    );
  }
}

export default LineEchart;

function setLineOption(xData = [], data = [], xBase = [], baseData = [], formatter) {
  // xBase=['2022-07-4','2022-07-5','2022-07-6'];
  // baseData=[1.5,1.6,1.098];
  const xDataN = [...new Set([...xData, ...xBase])].sort();
  
  const dayIncomeSeries = xData.map((v, i) => [v, data[i]]);
  const baseSeries = xBase.map((v, i) => [v, baseData[i]]);
  let option;
  option = {
    color: ["#BF9B79", "#CAD6E8"],
    grid: {
      left: "0%",
      right: "3%",
      bottom: "3%",
      containLabel: true,
    },
    xAxis: [
      {
        type: "category",
        boundaryGap: false,
        color: "#878787",
        fontSize: 9,
        fontWeight: 600,
        axisLine: {
          lineStyle: {
            width: 1,
            color: "#DFDFDF",
          },
        },
        axisTick: {
          lineStyle: {
            width: 0,
          },
        },
        axisLabel: {
          color: "#878787",
          align: "center",
          interval: (index, value) => {
            if (index == 0 || index == xDataN.length - 1 || index == xDataN.length / 2 - 1 || index == (xDataN.length - 1) / 2) {
              return value;
            }
            return false;
          },
          formatter: (value, index) => {
            if (index == 0) return `{start|${value.split("/").join("-")}}`;
            if (index == xDataN.length - 1) return `{end|${value.split("/").join("-")}}`;
            if (index == xDataN.length / 2 - 1 || index == (xDataN.length - 1) / 2) return `{middle|${value.split("/").join("-")}}`;
          },
          rich: {
            start: {
              width: "200%",
              align: "left",
            },
            end: {
              width: "0%",
              align: "right",
            },
            middle: {
              align: "center",
            },
          },
        },
        data: xDataN,
      },
    ],
    yAxis: [
      {
        type: "value",
        scale: true,
        // name:'(人)',
        axisLine: {
          lineStyle: {
            width: 0,
          },
        },
        axisTick: {
          lineStyle: {
            width: 0,
          },
        },
        axisLabel: {
          formatter: function (value, index) {
            return Util.toPercent(value);
          },
        },
        splitLine: {
          lineStyle: {
            color: "#DFDFDF",
            width: 1,
            type: "dotted",
          },
        },
      },
    ],
    animation: window.isLess47,

    tooltip: {
      show: true,
      trigger: "axis",
      alwaysShowContent: true,
      position: [0, 0],
      padding: [0, 0, 0, 0],
      transitionDuration: 0,
      triggerOn:'mousemove|click',
      axisPointer: {
        type: "line",
        lineStyle: {
          color: "#48b",
          width: 1,
          type: "dashed",
          opacity: 1,
        },
      },
      backgroundColor: "#FFF",
      extraCssText: "width:100%;",
      formatter: (params) => {
        return formatter(params);
      },
    },
    calculable: true,

    series: [
      {
        name: "本策略",
        type: "line",
        smooth: true /*线条有弧度*/,
        data: dayIncomeSeries,
        //animation: false,
        showSymbol:false,
        itemStyle: {
          normal: {
          },
        },
        areaStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: "rgba(191, 155, 121, 0.15)",
              },
              {
                offset: 1,
                color: "rgba(191, 155, 121, 0)",
              },
            ]),
          },
        },
      },
      {
        name: "业绩基准",
        type: "line",
        smooth: true,
        data: baseSeries,
        showSymbol:false,
        areaStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: "rgba(189, 200, 212, 0.15)",
              },
              {
                offset: 1,
                color: "rgba(189, 200, 212, 0)",
              },
            ]),
          },
        },
      },
    ],
  };

  return option;
}



// WEBPACK FOOTER //
// ./src/components/LineEchart.js